var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "area_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "area",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      label: _vm.$t(
                        "retailStoresInfo.form.storeFacEqu.storeArea"
                      ),
                    },
                  },
                  [
                    _c(
                      "FormInputNumber",
                      {
                        attrs: {
                          val: _vm.form.area,
                          step: 0.01,
                          mode: _vm.type,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "area", $event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("㎡")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "workingBay_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "workingBay",
                      rules: _vm.rules.iptEmpty,
                      label: _vm.$t(
                        "retailStoresInfo.form.storeFacEqu.worksNum"
                      ),
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: { val: _vm.form.workingBay, mode: _vm.type },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "workingBay", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "accountingMethod_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeFacEqu.accountMethod"
                      ),
                      prop: "accountingMethod",
                      rules: _vm.isBailianFlag ? _vm.rules.chooseEmpty : null,
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          disabled: _vm.type !== "edit",
                          placeholder: _vm.$t(
                            "retailStoresInfo.input.selectHolder"
                          ),
                        },
                        model: {
                          value: _vm.form.accountingMethod,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "accountingMethod", $$v)
                          },
                          expression: "form.accountingMethod",
                        },
                      },
                      _vm._l(
                        _vm.lookupList["DETAILS_ACCOUNTING_METHOD"],
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name,
                              value: item.code,
                              disabled: _vm.type !== "edit",
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-checkbox-group" },
          [
            _c(
              "el-form-item",
              {
                key: "laundry_" + (_vm.isBailianFlag ? "by" : ""),
                staticClass: "form-item-title",
                attrs: {
                  label: _vm.$t("retailStoresInfo.form.storeFacEqu.storeFac"),
                  prop: "laundry",
                  rules: _vm.rules.laundry,
                },
              },
              [
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t("retailStoresInfo.form.storeFacEqu.laundry"),
                  },
                  model: {
                    value: _vm.form.laundry,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "laundry", $$v)
                    },
                    expression: "form.laundry",
                  },
                }),
                _vm._v(" "),
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t("retailStoresInfo.form.storeFacEqu.restRoom"),
                  },
                  model: {
                    value: _vm.form.restRoom,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "restRoom", $$v)
                    },
                    expression: "form.restRoom",
                  },
                }),
                _vm._v(" "),
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t(
                      "retailStoresInfo.form.storeFacEqu.alignment"
                    ),
                  },
                  model: {
                    value: _vm.form.alignment,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "alignment", $$v)
                    },
                    expression: "form.alignment",
                  },
                }),
                _vm._v(" "),
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t("retailStoresInfo.form.storeFacEqu.fitting"),
                  },
                  model: {
                    value: _vm.form.fitting,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "fitting", $$v)
                    },
                    expression: "form.fitting",
                  },
                }),
                _vm._v(" "),
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t(
                      "retailStoresInfo.form.storeFacEqu.balancing"
                    ),
                  },
                  model: {
                    value: _vm.form.balancing,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "balancing", $$v)
                    },
                    expression: "form.balancing",
                  },
                }),
                _vm._v(" "),
                _c("el-checkbox", {
                  attrs: {
                    disabled: _vm.type !== "edit",
                    "true-label": "Y",
                    "false-label": "N",
                    label: _vm.$t("storeVisitReport.facAEq.liftMachine"),
                  },
                  model: {
                    value: _vm.form.liftingMachine,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "liftingMachine", $$v)
                    },
                    expression: "form.liftingMachine",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }